<script setup lang="ts">
import { computed } from 'vue';
import type { QuestionStatus } from '@/types/TestReview';

const props = defineProps<{
    label: QuestionStatus,
}>();

const iconName = computed(() => ({
    correct: 'o_check_circle',
    incorrect: 'o_cancel',
    flagged: 'o_flag',
    skipped: 'o_cancel',
}[props.label] || 'o_cancel'));

const iconClass = computed(() => ({
    correct: 'correct',
    incorrect: 'incorrect',
    flagged: 'flagged',
    skipped: 'skipped',
}[props.label] || 'incorrect'));

</script>

<template>
    <q-icon
        :name="iconName"
        class="answer-icon"
        :class="iconClass"
    />
</template>

<style scoped lang="scss">
.answer-icon {
    font-size: 20px;

    &.correct {
        color: var(--fsum-green);
    }
    &.incorrect {
        color: var(--fsum-red);
    }
    &.flagged {
        color: var(--fsum-secondary-blue);
    }
    &.skipped {
        color: var(--fsum-med-light-gray);
    }
}
</style>
